import {HStack, Stack, Text} from "@chakra-ui/react";
import {useGetTotalConfig} from "../../context/calculatorContext/context";
import {calculatePlanPrice} from "../../utils/calculatePlanPrice";

const Overview = (props) => {
  const {planType, selectedPlan = {}, selectedFrequency = {}, selectedOS = {}} = props;
  const {ramInGB, showInGB, totalCPU, totalRAM} = useGetTotalConfig();

  return (
    <Stack spacing={1}>
      <HStack>
        <Text color={"#111b27"} fontSize={"14px"} fontWeight={"500"}>
          Total CPU:
        </Text>
        <Text data-cy="total-cpu">{totalCPU}</Text>
      </HStack>
      <HStack>
        <Text color={"#111b27"} fontSize={"14px"} fontWeight={"500"}>
          Total RAM:
        </Text>
        <Text data-cy="total-ram">{showInGB ? `${ramInGB} GB` : `${totalRAM} MB`}</Text>
      </HStack>
      {planType !== "Custom" && (
        <HStack>
          <Text color={"#111b27"} fontSize={"14px"} fontWeight={"500"}>
            Total Cost:
          </Text>
          <Text data-cy="total-cost">
            $
            {Math.round(
              calculatePlanPrice(selectedPlan.prices, selectedFrequency) +
                calculatePlanPrice(selectedOS.prices, selectedFrequency)
            )}
          </Text>
        </HStack>
      )}
    </Stack>
  );
};

export default Overview;
